import z from 'zod'

import {
  amMobilityDataProviderEnum,
  amMobilityDataProviderSchema,
} from 'src/common-services/types/alphamap/mobility-types'
import { amDateShema } from 'src/common-services/types/alphamap'

export type CrossVisitRequest = {
  venueId: string
  start: string
  end: string
}

export type CrossVisitDate = {
  quarter: string
  start: string
  end: string
}

export type CrossVisitPlaceDate = Pick<CrossVisitDate, 'start'>

export type CrossVisitDateResponse = CrossVisitDate[]

export type CrossVisitResponse = {
  rank: number
  name: string
  personCount: number
  percentage: number
}

const crossVisitsByPlaceSchema = z.object({
  key: z.string().nonempty(),
  month: z.number(),
  day: z.number(),
})
export type CrossVisitsByPlace = z.infer<typeof crossVisitsByPlaceSchema>

// New cross visit types
export const crossVisitsByLocationSchema = z.object({
  locationId: z.string().nonempty(),
  provider: amMobilityDataProviderSchema.optional().default(amMobilityDataProviderEnum.Unacast),
  start: z.string().nonempty(),
  end: z.string().nonempty(),
})
export type CrossVisitByLocationRequest = z.infer<typeof crossVisitsByLocationSchema>

const crossVisitsDayByPlaceSchema = z.object({
  key: z.string().nonempty(),
  day: z.number(),
  logo: z.string().optional(),
  locationId: z.string().optional(),
  brandId: z.string().optional(),
  brandName: z.string().optional(),
  distance: z.number().optional(),
})
export type CrossVisitsDayByPlace = z.infer<typeof crossVisitsDayByPlaceSchema>

const crossVisitsMonthByPlaceSchema = z.object({
  key: z.string().nonempty(),
  month: z.number(),
  logo: z.string().optional(),
  locationId: z.string().optional(),
  brandId: z.string().optional(),
  brandName: z.string().optional(),
  distance: z.number().optional(),
})
export type CrossVisitsMonthByPlace = z.infer<typeof crossVisitsMonthByPlaceSchema>

export const crossVisitByLocationResponseSchema = z.object({
  day: z.array(crossVisitsDayByPlaceSchema),
  month: z.array(crossVisitsMonthByPlaceSchema),
})
export type CrossVisitByLocationResponse = z.infer<typeof crossVisitByLocationResponseSchema>

export const amMobilityBrandCrossVisitationRequestSchema = z.object({
  locationId: z.string(), // so that we can get nearest locations to this specific branded location
  brandId: z.string(),
  from: amDateShema,
  to: amDateShema,
})
export type AMMobilityBrandCrossVisitationRequest = z.infer<typeof amMobilityBrandCrossVisitationRequestSchema>

export const amMobilityCrossVisitationByBrandResponseSchema = z.object({
  month: z.array(crossVisitsMonthByPlaceSchema),
})
export type AMMobilityBrandCrossVisitationResponse = z.infer<typeof amMobilityCrossVisitationByBrandResponseSchema>
